module.exports = __webpack_public_path__ + "static/media/invite_clinicians.52638fc9.svg";